<template>
  <div class="formula-tooltip">
    <StakeTooltip
      :label="tooltipContent"
      position="top"
      trigger="hover"
      :active="!!props.formula"
    >
      <slot />
    </StakeTooltip>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { StakeTooltip } from '@stakeui';

const props = defineProps({
  formula: {
    type: Object,
    required: true,
  },
  entityExternalId: {
    type: String,
    required: true,
  },
});

const tooltipContent = computed(() => {
  if (!props.formula) return '';

  const { formula, calculation, dossier_section: dossierSection } = props.formula;

  return `Formula: ${formula}
  
Calculation: ${calculation}

Update in Dossier: ${dossierSection}`;
});
</script>

<style scoped>
.formula-tooltip {
  display: inline-block;
  cursor: help;
}

.formula-tooltip:hover {
  text-decoration: underline;
  text-decoration-style: dotted;
}
</style>